
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AssistantChatProps } from './types';
import ChatHeader from './ChatHeader';
import MessageList from './MessageList';
import ChatInput from './ChatInput';
import ErrorState from './ErrorState';
import LoadingState from './LoadingState';
import { useAssistantChat } from './useAssistantChat';

const AssistantChat: React.FC<AssistantChatProps> = ({ trip }) => {
  const {
    messages,
    isLoading,
    isInitializing,
    connectionError,
    threadId,
    handleRetry,
    sendMessage
  } = useAssistantChat(trip);

  if (connectionError) {
    return (
      <Card className="flex flex-col h-[70vh] overflow-hidden">
        <ChatHeader />
        <ErrorState errorMessage={connectionError} onRetry={handleRetry} />
      </Card>
    );
  }

  if (isInitializing) {
    return (
      <Card className="flex flex-col h-[70vh] overflow-hidden">
        <ChatHeader />
        <LoadingState />
      </Card>
    );
  }

  return (
    <Card className="flex flex-col h-[70vh] overflow-hidden">
      <ChatHeader />
      
      <CardContent className="flex flex-col flex-1 p-4 pt-2 overflow-hidden">
        <MessageList 
          messages={messages} 
          isLoading={isLoading} 
        />
        
        <ChatInput 
          onSendMessage={sendMessage}
          isLoading={isLoading}
          disabled={!threadId}
        />
      </CardContent>
    </Card>
  );
};

export default AssistantChat;
